<template>
  <div class="animated fadeIn">
    <b-row>
      <OEMBacklog
        :lgSize="12"
        :lgOffset="0"
        :locParam="1"
        :idCity="0"
      ></OEMBacklog>

      <OEMDelivered
        :lgSize="12"
        :lgOffset="0"
        :locParam="1"
        :idCity="0"
      ></OEMDelivered>
    </b-row>
  </div>
</template>

<script>
import OEMBacklog from "../../components/OEMBacklog-Stacked";
import OEMDelivered from "../../components/OEMDelivered-Stacked";

import { Chart } from "highcharts-vue";
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  name: "dashboard",
  components: {
    OEMBacklog,
    OEMDelivered,
    highcharts: Chart
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
